import i18n, { ReadCallback } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

/**
 * Function to call at the top level of any app requiring translations,
 * to initialise i18n instance and config
 *
 * Do not call this inside a react component
 */
export const initialiseTranslations = (
    importCallback?: (lang: string, clb: ReadCallback) => void
) => {
    i18n.use(initReactI18next)
        .use(ChainedBackend)
        .use(LanguageDetector)
        .init({
            fallbackLng: 'en-US',
            debug: false,
            supportedLngs: ['en-US'],
            backend: {
                backends: [
                    /**
                     * if a namespace can't be loaded via normal http-backend loadPath, then
                     * the inMemoryLocalBackend will try to return the correct resources
                     */
                    HttpBackend,
                    resourcesToBackend((lng, _ns, callback) => {
                        if (!importCallback) {
                            import(`./locales/${lng}.json`)
                                .then(({ default: resources }) => {
                                    callback(null, resources);
                                })
                                .catch((error) => {
                                    callback(error, null);
                                });
                        } else {
                            importCallback(lng, callback);
                        }
                    }),
                ],
            },
        });
    return i18n;
};
